import {
  AdminExamsPaymentMethod,
  CurriculumDisicplineTypes,
  AnnualFeeModes,
  NacidFailureClass,
  NacidFlowSource,
  PublicationSource,
  NacidFlowStatus,
  NacidFlowStepStatus,
  NacidFlowType,
  NacidProbeOutcome,
  CareerRequestStatus,
  DecisionReasons,
  DormitoryBuildingStatuses,
  DormitoryRoomStatuses,
  DormitoryRoomTypeStatuses,
  DormitoryRoomConditionStatuses,
  DormitoryCampaignApplicantTypes,
  DormitoryCampaignStatuses,
  DormitoryAccommodationOrderStatuses,
  DormitoryAccommodationPaymentReportingStates,
  DormitoryAccommodationPaymentStatuses,
  DormitoryManualPaymentMethods,
  DormitoryAccommodationStatuses,
  DormitorySettingTypes,
  DormitoryStudentTypes,
  DormitoryRoomExpositions,
  RankingResultCategory,
  RankingResultStatus,
  RankingStatus,
  RankingType,
  ScoreComponentSource,
  SpecialityStatusSource,
  CurrencyTypes,
  UserRoles,
  DebtStatus,
  DepositAction,
  PaymentProvider,
  TravelerKinds,
  IndividualCurriculumStatus,
  HealthcareApplicationOrigin,
} from "./constants";

export const ScienceDegreeOptions = [
  { id: "Bachelor", name: "Бакалавър" },
  { id: "Master", name: "Магистър" },
  { id: "Assistant", name: "Асистент " },
  { id: "ChiefAssistant", name: "Главен асистент" },
  { id: "Docent", name: "Доцент" },
  { id: "Doctor", name: "Доктор" },
  { id: "Professor", name: "Професор" },
];

export const EmployeeTypeOptions = [
  { id: "Administration", name: "Администрация" },
  { id: "Teacher", name: "Преподавател" },
];

export const DirectSupervisorOptions = [
  { id: "HeadDepartment", name: "Ръководител катедра" },
  { id: "HeadTeam", name: "Ръководител отдел" },
];

export const SexOptions = [
  { id: "Male", name: "Мъж" },
  { id: "Female", name: "Жена" },
];

export const GenderOptionsId = [
  { id: 1, name: "Мъж" },
  { id: 2, name: "Жена" },
];

// Erasmus incoming students may decline to state their gender - the shared list has no such option.
export const IncomingStudentGenderOptions = [...GenderOptionsId, { id: 3, name: "Предпочитам да не казвам" }];

export const PmsOptions = [
  { id: 1, name: "ПМС 103" },
  { id: 2, name: "ПМС 228" },
];

export const PersonIdTypes = [
  { id: 1, name: "ЕГН" },
  { id: 2, name: "ЛНЧ" },
  { id: 3, name: "ПИД" },
];

export const RoomClassTypeOptions = [
  {
    id: "1",
    name: "КСК",
  },
  {
    id: "2",
    name: "Лекции",
  },
  {
    id: "3",
    name: "Упражнения",
  },
  {
    id: "4",
    name: "Практика",
  },
];

export const CitizenTypeOptions = [
  {
    id: 1,
    name: "Българско",
  },
  {
    id: 2,
    name: "Европейско",
  },
  {
    id: 3,
    name: "Трета страна",
  },
];

export const TransactionStatusChoices = [
  { id: 0, name: "Платено" },
  { id: 1, name: "Не е платено" },
  { id: 2, name: "Очаква плащане" },
];

export const ExamTypeChoices = [
  { id: "1", name: "Дистанционен" },
  { id: "2", name: "Присъствен" },
];

export const CurriculumDisciplineTypeChoices = [
  { id: "1", name: "Основна" },
  { id: "2", name: "Циклична" },
  { id: "3", name: "Стаж" },
];

export const CurriculumControlType = [
  { id: "0", name: "Изпит" },
  { id: "1", name: "Текуща оценка" },
  { id: "2", name: "Комплексна оценка" },
];

export const CitizenTypeForeigner = [
  { id: 3, name: "Не" },
  { id: 2, name: "Да" },
];

export const PreviousEducationType = [
  { id: 1, name: "Средно образование" },
  { id: 2, name: "Висше образование" },
];
export const LanguageOptions = [
  { id: 1, name: "Български" },
  { id: 2, name: "Английски" },
];

export const AttestationStatusChoices = [
  { id: 1, name: "Заверен" },
  { id: 2, name: "Незаверен" },
  { id: 3, name: "Чака заверка" },
];

export const CurriculumDisciplineTypeLabels = [
  { id: CurriculumDisicplineTypes.None, name: "Извън учебния план" },
  { id: CurriculumDisicplineTypes.Regular, name: "Основна" },
  { id: CurriculumDisicplineTypes.Elective, name: "Избираема" },
  { id: CurriculumDisicplineTypes.Facultative, name: "Факултативна" },
  { id: CurriculumDisicplineTypes.Cyclic, name: "Циклична" },
];

// Numeric counterpart of RoomClassTypeOptions — the attestation endpoints send and expect numbers.
export const ClassTypeChoices = [
  // Ksk is rejected by the attestations endpoint (400 EC_Invalid_Argument_Attestations_ClassTypeId),
  // so it cannot be picked for a new attestation. Existing Ksk rows still display their own name.
  // { id: 1, name: "КСК" },
  { id: 2, name: "Лекции" },
  { id: 3, name: "Упражнения" },
  { id: 4, name: "Практика" },
];

export const FromWeekToWeekChoices = [
  { id: 1, name: "Седмица 1" },
  { id: 2, name: "Седмица 2" },
  { id: 3, name: "Седмица 3" },
  { id: 4, name: "Седмица 4" },
  { id: 5, name: "Седмица 5" },
  { id: 6, name: "Седмица 6" },
  { id: 7, name: "Седмица 7" },
  { id: 8, name: "Седмица 8" },
  { id: 9, name: "Седмица 9" },
  { id: 10, name: "Седмица 10" },
  { id: 11, name: "Седмица 11" },
  { id: 12, name: "Седмица 12" },
  { id: 13, name: "Седмица 13" },
  { id: 14, name: "Седмица 14" },
  { id: 15, name: "Седмица 15" },
];
export const WeekTypeChoices = [
  { id: 1, name: "Всяка седмица" },
  { id: 2, name: "Четни седмици" },
  { id: 3, name: "Нечетни седмици" },
];

export const WeekDaysChoices = [
  { id: 1, name: "Понеделник" },
  { id: 2, name: "Вторник" },
  { id: 3, name: "Сряда" },
  { id: 4, name: "Четвъртък" },
  { id: 5, name: "Петък" },
  { id: 6, name: "Събота" },
  { id: 7, name: "Неделя" },
];

export const SemestersChoices = [
  { id: 1, name: "Семестър 1" },
  { id: 2, name: "Семестър 2" },
  { id: 3, name: "Семестър 3" },
  { id: 4, name: "Семестър 4" },
  { id: 5, name: "Семестър 5" },
  { id: 6, name: "Семестър 6" },
  { id: 7, name: "Семестър 7" },
  { id: 8, name: "Семестър 8" },
  { id: 9, name: "Семестър 9" },
  { id: 10, name: "Семестър 10" },
  { id: 11, name: "Семестър 11" },
  { id: 12, name: "Семестър 12" },
];

// Preparatory schedule periods repeat on these week days; an EMPTY selection means EVERY day.
export const WeekDayChoices = [
  { id: 1, name: "Понеделник" },
  { id: 2, name: "Вторник" },
  { id: 3, name: "Сряда" },
  { id: 4, name: "Четвъртък" },
  { id: 5, name: "Петък" },
  { id: 6, name: "Събота" },
  { id: 7, name: "Неделя" },
];

// Preparatory periods only allow these three (no КСК).
export const PreparatoryClassTypeChoices = [
  { id: 2, name: "Лекции" },
  { id: 3, name: "Упражнения" },
  { id: 4, name: "Практика" },
];

export const CourseChoices = [
  { id: 1, name: "1-ви Курс" },
  { id: 2, name: "2-ри Курс" },
  { id: 3, name: "3-ти Курс" },
  { id: 4, name: "4-ти Курс" },
  { id: 5, name: "5-ти Курс" },
  { id: 6, name: "6-ти Курс" },
];
export const GradingTypeOptions = [
  { id: 1, name: "Оценка" },
  { id: 2, name: "Заверка" },
];

export const IndividualCurriculumStatusChoices = [
  { id: IndividualCurriculumStatus.SignedOffWithoutExam, name: "Заверен семестър без взет изпит" },
  { id: IndividualCurriculumStatus.SignedOffWithExam, name: "Заверен семестър и взет изпит" },
  { id: IndividualCurriculumStatus.NotAttended, name: "Непосещавал" },
  { id: IndividualCurriculumStatus.Deferred, name: "Отложена (не се изучава тази година)" },
];

export const StatusExamsChoices = [
  { id: 2, name: "Неявил се" },
  { id: 3, name: "Присъствал" },
  { id: 4, name: "Отстранен" },
];
export const StudentExamStatusChoices = [
  { id: 1, name: "Чакащ" },
  { id: 2, name: "Неявил се" },
  { id: 3, name: "Явил се" },
  { id: 4, name: "Отстранен" },
];
export const EmailRequestStatus = [
  { id: "sent", name: "Изпратен" },
  { id: "failed", name: "Неуспешно" },
  { id: "sending", name: "Изпращане" },
  { id: "waitingBulk", name: "В изчакване" },
];

// Shared professor-role enum for exam commissions (session, cyclic and state exams).
export const ExamCommissionRoles = [
  { id: 0, name: "Изпитващ" },
  { id: 1, name: "Председател на комисията" },
  { id: 2, name: "Член на комисията" },
  { id: 3, name: "Резервен член" },
];

export const ExamCommitteeMemberTypeChoices = [
  { id: 1, name: "Председател" },
  { id: 2, name: "Член" },
];

export const ExamCommitteeStatusChoices = [
  { id: 1, name: "Активна" },
  { id: 2, name: "Неактивна" },
];

export const HealthcareApplicationOriginChoices = [
  { id: HealthcareApplicationOrigin.PublicForm, name: "Публична форма" },
  { id: HealthcareApplicationOrigin.Admin, name: "Администрация" },
];

export const AcademicRequestTypeChoices = [
  { id: 1, name: "Академичен доклад" },
  { id: 2, name: "Уверение за кредит" },
  { id: 3, name: "Проблем с прехвърлените данни" },
];

export const AcademicRequestStatus = [
  { id: 1, name: "Чакащ" },
  { id: 2, name: "Готов" },
  { id: 3, name: "Отказан" },
];

export const StaffRequestType = [
  { id: 1, name: "Заместване на преподавател" },
  { id: 2, name: "Отработване на упражнения" },
  { id: 3, name: "Заявки за отпуска" },
  { id: 4, name: "Заявка за болничен" },
  { id: 5, name: "Командировка" },
  { id: 6, name: "Еразъм подпис" },
  { id: 7, name: "Заявка за отмяна" },
];

export const StaffRequestStatus = [
  { id: 0, name: "Чакащ" },
  { id: 1, name: "Одобрен" },
  { id: 2, name: "Отказан" },
  { id: 3, name: "Отменен" },
];

export const NotPastExamsStudentsTypeChoices = [
  { id: 1, name: "Брой студенти" },
  { id: 2, name: "Факултетни номера" },
];
export const IntendedForChoices = [
  { id: 1, name: "Редовно явяващи се студенти" },
  { id: 2, name: "Редовно явяващи се и скъсани студенти" },
  { id: 3, name: "САМО за скъсани студенти" },
  { id: 4, name: "САМО за студенти в удължена сесия" },
];

export const DecisionReasonChoices = [
  { id: DecisionReasons.MissingAttestations, name: "Липсващи заверки" },
  { id: DecisionReasons.FailedRequiredDiscipline, name: "Невзет задължителен изпит" },
  { id: DecisionReasons.FailedTooManyDisciplines, name: "Брой невзети изпити" },
  { id: DecisionReasons.FailedCarryOverDisciplines, name: "Изпити от минали години" },
];

export const SchorashipTypeChoices = [
  { id: 1, name: "Въз основа на оценка" },
  { id: 2, name: "Въз основа на оценка и доход" },
  { id: 3, name: "Въз основа на доход" },
  { id: 4, name: "Международен обмен" },
];

export const ScholarshipCategoryChoices = [
  { id: 1, name: "Социална подкрепа" },
  { id: 2, name: "Майчинство" },
  { id: 3, name: "Бащинство" },
  { id: 4, name: "Военно семейство" },
  { id: 5, name: "Докторантура" },
  { id: 6, name: "Чудженци" },
];

export const ScholarshipStatusesChoices = [
  { id: -1, name: "Блокиран" },
  { id: 0, name: "Чакаща" },
  { id: 1, name: "Одобрена" },
  { id: 2, name: "Некласиран" },
  { id: 3, name: "Чакаща счетоводство" },
  { id: 4, name: "Върната за корекция" },
];

export const CareerRequestStatusChoices = [
  { id: CareerRequestStatus.Inactive, name: "Неактивен" },
  { id: CareerRequestStatus.NotVerifiedValidationCode, name: "Не е валидиран" },
  { id: CareerRequestStatus.WaitingForCorrection, name: "В очакване на корекция" },
  { id: CareerRequestStatus.Active, name: "Активен" },
  { id: CareerRequestStatus.CorrectionApplied, name: "Одобрена корекция" },
  { id: CareerRequestStatus.Rejected, name: "Отказан" },
];

export const YearChoices = [
  { id: 2026, name: "2026" },
  { id: 2027, name: "2027" },
  { id: 2028, name: "2028" },
  { id: 2029, name: "2029" },
  { id: 2030, name: "2030" },
];

export const BusinessTripMealProvidedChoices = [
  { id: true, name: "Да" },
  { id: false, name: "Не" },
];

export const TravelerKindChoices = [
  { id: TravelerKinds.Employee, name: "Служител" },
  { id: TravelerKinds.External, name: "Външно лице" },
  { id: TravelerKinds.Doctoral, name: "Докторант" },
  { id: TravelerKinds.Student, name: "Студент" },
];

export const LeaveTypeChoices = [
  { id: 1, name: "Отпуска" },
  { id: 2, name: "Командировка" },
  { id: 3, name: "Болничен" },
];

export const StateExamAssignmentTypeChoices = [
  { id: 1, name: "Избираем" },
  { id: 2, name: "За учебни групи" },
];

export const StateExamTypeChoices = [
  { id: 1, name: "Единичен" },
  { id: 2, name: "Групов" },
];

export const StudyDurationUnitChoices = [
  { id: 1, name: "Дни" },
  { id: 2, name: "Месеци" },
];

export const BuildingsIsExternalChoices = [
  { id: true, name: "Да" },
  { id: false, name: "Не" },
];

export const CurriculumItemTypeChoices = [
  { id: 1, name: "Теоретично обучение" },
  { id: 2, name: "Практическо обучение" },
  { id: 3, name: "Колоквиум" },
];

export const SpecialistTaxTypeChoices = [
  { id: 1, name: "Практика" },
  { id: 2, name: "Теория" },
];

export const SpecialistTaxBillingPeriodChoices = [
  { id: 1, name: "Месечно" },
  { id: 2, name: "Годишно" },
];

export const ScoreComponentSourceChoices = [
  { id: ScoreComponentSource.Exam, name: "Изпит" },
  { id: ScoreComponentSource.SchoolSubject, name: "Училищен предмет" },
];

export const RankingStatusChoices = [
  { id: RankingStatus.Pending, name: "Предстоящо" },
  { id: RankingStatus.Draft, name: "Очаква одобрение" },
  { id: RankingStatus.Approved, name: "Одобрено" },
];

export const CandidateCampaignRankingTypeChoices = [
  { id: RankingType.State, name: "Държавна поръчка" },
  { id: RankingType.Paid, name: "Платено обучение" },
  { id: RankingType.HospitalContract, name: "Договор с болница" },
];

export const RankingResultStatusChoices = [
  { id: RankingResultStatus.NotAccepted, name: "Неприет" },
  { id: RankingResultStatus.Accepted, name: "Приет" },
  { id: RankingResultStatus.Enrolled, name: "Записан" },
  { id: RankingResultStatus.DroppedOut, name: "Отпаднал" },
  { id: RankingResultStatus.AcceptedInHigherPriority, name: "Приет в по-високо желание" },
  { id: RankingResultStatus.TransferredToStateOrder, name: "Прехвърлен в държавна поръчка" },
];

export const RankingResultCategoryChoices = [
  { id: RankingResultCategory.Common, name: "Обща" },
  { id: RankingResultCategory.Men, name: "Мъже" },
  { id: RankingResultCategory.Women, name: "Жени" },
  { id: RankingResultCategory.Preferences, name: "С преференции" },
  { id: RankingResultCategory.RestoredRights, name: "Възстановяващ права" },
];

export const SpecialityStatusChoices = [
  { id: SpecialityStatusSource.Active, name: "Активна" },
  { id: SpecialityStatusSource.NoAdmission, name: "Без нов прием" },
  { id: SpecialityStatusSource.Inactive, name: "Неактивна" },
];

export const ReportsCampaignSubTypeChoices = [
  { id: 1, name: "Предварителна" },
  { id: 2, name: "Редовна" },
  { id: 4, name: "Платено обучение" },
  { id: 6, name: "Договор с болница" },
];

export const AdminExamsPaymentMethodChoices = [
  { id: AdminExamsPaymentMethod.CashPayment, name: "Да, на каса" },
  { id: AdminExamsPaymentMethod.BankTransfer, name: "Да, по банка" },
  { id: AdminExamsPaymentMethod.NoPayment, name: "Не" },
];

export const DoctoralSeatStatusChoices = [
  { id: 1, name: "Чака одобрение" },
  { id: 2, name: "Одобрено от ФС" },
  { id: 3, name: "Одобрено от АС" },
  { id: 4, name: "Одобрено от МОН" },
  { id: 5, name: "Отхвърлено" },
];

export const DoctoralSeatStatusColorMap = {
  1: "default",
  2: "info",
  3: "primary",
  4: "success",
  5: "error",
};

export const DoctorantCandidacyStatusChoices = [
  { id: 1, name: "Подадена" },
  { id: 2, name: "Допуска се до изпит" },
  { id: 3, name: "Недопусната" },
  { id: 4, name: "Възражение за разглеждане" },
  { id: 5, name: "Отхвърлена" },
  { id: 6, name: "Допуска се до изпит по език" },
  { id: 7, name: "Неуспешно положен изпит" },
  { id: 8, name: "Класиран (приет)" },
  { id: 9, name: "Некласиран" },
];

export const DoctorantCandidacyStatusColorMap = {
  1: "default",
  2: "success",
  3: "warning",
  4: "info",
  5: "error",
  6: "success",
  7: "error",
  8: "success",
  9: "warning",
};

export const PracticalExamStatusChoices = [
  { id: 1, name: "Няма оценка" },
  { id: 2, name: "Положен" },
  { id: 3, name: "Неположен" },
];

export const PracticalExamStatusColorMap = {
  1: "default",
  2: "success",
  3: "error",
};

export const DoctoralRankingStatusChoices = [
  { id: 1, name: "Предстоящо" },
  { id: 2, name: "Очаква одобрение" },
  { id: 3, name: "Одобрено" },
];

export const DoctoralSchoolCampaignStatusChoices = [
  { id: 1, name: "Чернова" },
  { id: 2, name: "Отворена за записване" },
  { id: 3, name: "В процес" },
  { id: 4, name: "Приключила" },
];

export const DoctoralSchoolCampaignStatusColorMap = {
  1: "default",
  2: "info",
  3: "primary",
  4: "success",
};

export const DoctoralSchoolDoctorantStatusChoices = [
  { id: 1, name: "Очаква плащане" },
  { id: 2, name: "Приет" },
];

export const DoctoralSchoolDoctorantStatusColorMap = {
  1: "warning",
  2: "success",
};

export const DoctoralSchoolDoctorantOriginChoices = [
  { id: 1, name: "Докторант от университета" },
  { id: 2, name: "Външен" },
];

export const DoctoralSchoolResultChoices = [
  { id: 1, name: "Изкарал" },
  { id: 2, name: "Неизкарал" },
];

export const DoctoralSchoolResultColorMap = {
  1: "success",
  2: "error",
};

export const DoctoralSchoolFeeCategoryChoices = [
  { id: 1, name: "Редовни докторанти" },
  { id: 2, name: "Задочни докторанти и докторанти на самостоятелна подготовка" },
  { id: 3, name: "Академичен състав на МУ - София" },
  { id: 4, name: "Докторанти, обучаващи се на английски език" },
  { id: 5, name: "Външни лица" },
];

export const DoctoralSchoolPaymentProviderChoices = [
  { id: 4, name: "На място (карта/в брой)" },
  { id: 3, name: "Банков превод" },
];

export const DoctoralRankingResultStatusChoices = [
  { id: 1, name: "Неприет" },
  { id: 2, name: "Приет" },
  { id: 3, name: "Приет в по-високо желание" },
  { id: 4, name: "Записан" },
];

export const DoctoralRankingResultStatusColorMap = {
  1: "error",
  2: "success",
  3: "info",
  4: "primary",
};

export const DoctorantStatusChoices = [
  { id: 1, name: "Действащ" },
  { id: 2, name: "Отчисляване с право на защита" },
  { id: 3, name: "Отчислен поради изтекъл срок" },
  { id: 4, name: "Отчисляване без право на защита" },
  { id: 5, name: "Защитил успешно" },
  { id: 6, name: "Прекъснал" },
];

export const DoctorantStatusColorMap = {
  1: "success",
  2: "info",
  3: "warning",
  4: "error",
  5: "success",
  6: "default",
};

export const DoctorantInterruptionTypeChoices = [
  { id: 1, name: "За 1 година" },
  { id: 2, name: "За 3 години" },
];

export const DoctorantDefenseResultChoices = [
  { id: 1, name: "Защитил успешно" },
  { id: 2, name: "Неуспешна защита" },
  { id: 3, name: "Не се явил" },
];

export const DoctorantDefenseResultColorMap = {
  1: "success",
  2: "error",
  3: "warning",
};

export const DoctorantReportProtocolTypeChoices = [
  { id: 1, name: "Тримесечен" },
  { id: 2, name: "Годишен" },
];

export const DoctorantChangeActionChoices = [
  { id: 1, name: "Промяна на тема" },
  { id: 2, name: "Добавен научен ръководител" },
  { id: 3, name: "Премахнат научен ръководител" },
];

export const DoctorantReportStatusChoices = [
  { id: 1, name: "Много добра" },
  { id: 2, name: "Добра" },
  { id: 3, name: "Незадоволителна" },
  { id: 4, name: "Отрицателна" },
];

export const DoctorantReportStatusColorMap = {
  1: "success",
  2: "info",
  3: "warning",
  4: "error",
};

export const DoctoralStudyTypeChoices = [
  { id: 1, name: "Редовно" },
  { id: 2, name: "Задочно" },
  { id: 3, name: "Свободно" },
];

export const DoctoralStudyTypeLabels = {
  1: "Редовно",
  2: "Задочно",
  3: "Свободно",
};

export const DebtStatusChoices = [
  { id: DebtStatus.Unpaid, name: "Неплатено" },
  { id: DebtStatus.Paid, name: "Платено" },
  { id: DebtStatus.Cancelled, name: "Анулирано" },
];

export const DebtPaymentProviderChoices = [
  { id: PaymentProvider.BankTransfer, name: "Банков превод" },
  { id: PaymentProvider.CashPayment, name: "На каса" },
];

export const CurrencyChoices = [
  { id: CurrencyTypes.BGN, name: "BGN" },
  { id: CurrencyTypes.EUR, name: "EUR" },
];

export const DepositActionChoices = [
  { id: DepositAction.Create, name: "Създаване" },
  { id: DepositAction.Use, name: "Използване" },
];

export const UserRoleChoices = [
  { id: UserRoles.Candidate, name: "Кандидат-студент" },
  { id: UserRoles.Student, name: "Студент" },
  { id: UserRoles.Specialist, name: "Специализант" },
  { id: UserRoles.Doctorant, name: "Докторант" },
];

export const AddressTypeChoices = [
  { id: 1, name: "Постоянен адрес" },
  { id: 2, name: "Адрес за кореспонденция" },
];
export const NationalityType = [
  { id: 1, name: "Българин" },
  { id: 2, name: "Чужденец" },
];

export const DormitoryBuildingStatusChoices = [
  { id: DormitoryBuildingStatuses.Active, name: "Активен" },
  { id: DormitoryBuildingStatuses.Inactive, name: "Неактивен" },
];
export const DormitoryCampaignStatusChoices = [
  { id: DormitoryCampaignStatuses.Draft, name: "Чернова" },
  { id: DormitoryCampaignStatuses.Confirmed, name: "Потвърдена" },
  { id: DormitoryCampaignStatuses.Finished, name: "Приключена" },
  { id: DormitoryCampaignStatuses.Cancelled, name: "Отказана" },
];
export const DormitoryCampaignApplicantTypeChoices = [
  { id: DormitoryCampaignApplicantTypes.Internal, name: "Студенти на университета" },
  { id: DormitoryCampaignApplicantTypes.External, name: "Външни лица" },
];
export const DormitoryStudentTypeChoices = [
  { id: DormitoryStudentTypes.Bachelor, name: "Бакалавър" },
  { id: DormitoryStudentTypes.Master, name: "Магистър" },
  { id: DormitoryStudentTypes.Doctoral, name: "Докторант" },
];

export const DormitoryAccommodationOrderStatusChoices = [
  { id: DormitoryAccommodationOrderStatuses.Draft, name: "Чернова" },
  { id: DormitoryAccommodationOrderStatuses.ForSignature, name: "За подпис" },
  { id: DormitoryAccommodationOrderStatuses.Signed, name: "Подписана" },
  { id: DormitoryAccommodationOrderStatuses.Cancelled, name: "Отказана" },
];

export const DormitoryAccommodationPaymentStatusChoices = [
  { id: DormitoryAccommodationPaymentStatuses.Pending, name: "Неплатена" },
  { id: DormitoryAccommodationPaymentStatuses.Paid, name: "Платена" },
];

export const DormitoryOutstandingDebtChoices = [
  { id: true, name: "С неплатени задължения" },
  { id: false, name: "Без неплатени задължения" },
];

export const DormitoryAccommodationPaymentReportingStateChoices = [
  { id: DormitoryAccommodationPaymentReportingStates.NotAttempted, name: "Неизпратено" },
  { id: DormitoryAccommodationPaymentReportingStates.InProgress, name: "В процес" },
  { id: DormitoryAccommodationPaymentReportingStates.Confirmed, name: "Потвърдено" },
  { id: DormitoryAccommodationPaymentReportingStates.ReviewRequired, name: "За проверка" },
];

export const DormitoryManualPaymentMethodChoices = [
  { id: DormitoryManualPaymentMethods.Cash, name: "В брой" },
  { id: DormitoryManualPaymentMethods.BankTransfer, name: "Банков превод" },
];

export const DormitoryRoomTypeStatusChoices = [
  { id: DormitoryRoomTypeStatuses.Active, name: "Активен" },
  { id: DormitoryRoomTypeStatuses.Inactive, name: "Неактивен" },
];

export const DormitoryRoomConditionStatusChoices = [
  { id: DormitoryRoomConditionStatuses.Active, name: "Активно" },
  { id: DormitoryRoomConditionStatuses.Inactive, name: "Неактивно" },
];

export const DormitoryRoomStatusChoices = [
  { id: DormitoryRoomStatuses.Active, name: "Активна" },
  { id: DormitoryRoomStatuses.Inactive, name: "Неактивна" },
];

export const DormitorySettingTypeChoices = [
  { id: DormitorySettingTypes.ExtraBedMarkup, name: "Коефициент за допълнително легло" },
];

export const DormitoryAccommodationStatusChoices = [
  { id: DormitoryAccommodationStatuses.Active, name: "Настанен" },
  { id: DormitoryAccommodationStatuses.Left, name: "Напуснал" },
];

export const AnnualFeeModeChoices = [
  { id: AnnualFeeModes.Calculated, name: "По формула" },
  { id: AnnualFeeModes.Fixed, name: "Твърда цена" },
];

export const DormitoryRoomExpositionChoices = [
  { id: DormitoryRoomExpositions.North, name: "Север" },
  { id: DormitoryRoomExpositions.South, name: "Юг" },
  { id: DormitoryRoomExpositions.East, name: "Изток" },
  { id: DormitoryRoomExpositions.West, name: "Запад" },
  { id: DormitoryRoomExpositions.Northeast, name: "Североизток" },
  { id: DormitoryRoomExpositions.Southeast, name: "Югоизток" },
  { id: DormitoryRoomExpositions.Southwest, name: "Югозапад" },
  { id: DormitoryRoomExpositions.Northwest, name: "Северозапад" },
  { id: DormitoryRoomExpositions.Center, name: "Център" },
];

export const MonthsOfTheYear = [
  { id: 1, name: "Януари" },
  { id: 2, name: "Февруари" },
  { id: 3, name: "Март" },
  { id: 4, name: "Април" },
  { id: 5, name: "Май" },
  { id: 6, name: "Юни" },
  { id: 7, name: "Юли" },
  { id: 8, name: "Август" },
  { id: 9, name: "Септември" },
  { id: 10, name: "Октомври" },
  { id: 11, name: "Ноември" },
  { id: 12, name: "Декември" },
];

// ---------------------------------------------------------------------------------------------------------
// НАЦИД flow engine
//
// Labels are copied verbatim from the backend's [DisplayText] attributes so the panel and Swagger never
// disagree. Colours encode what an operator must *do*, not merely what happened:
// warning = a human is required, error = terminal, success = nothing owed.
// ---------------------------------------------------------------------------------------------------------

export const NacidFlowStatusChoices = [
  { id: NacidFlowStatus.Pending, name: "Чакащ" },
  { id: NacidFlowStatus.InProgress, name: "В изпълнение" },
  { id: NacidFlowStatus.WaitingForRetry, name: "Чака повторен опит" },
  { id: NacidFlowStatus.WaitingForManualAction, name: "Чака ръчна намеса" },
  { id: NacidFlowStatus.Completed, name: "Завършен" },
  { id: NacidFlowStatus.Failed, name: "Неуспешен" },
  { id: NacidFlowStatus.Cancelled, name: "Отказан" },
];

export const NacidFlowStatusColorMap = {
  [NacidFlowStatus.Pending]: "default",
  [NacidFlowStatus.InProgress]: "primary",
  [NacidFlowStatus.WaitingForRetry]: "info",
  [NacidFlowStatus.WaitingForManualAction]: "warning",
  [NacidFlowStatus.Completed]: "success",
  [NacidFlowStatus.Failed]: "error",
  [NacidFlowStatus.Cancelled]: "default",
};

export const NacidFlowStepStatusChoices = [
  { id: NacidFlowStepStatus.Pending, name: "Чакаща" },
  { id: NacidFlowStepStatus.InProgress, name: "В изпълнение" },
  { id: NacidFlowStepStatus.Succeeded, name: "Успешна" },
  { id: NacidFlowStepStatus.SkippedAlreadyApplied, name: "Пропусната - вече приложена" },
  { id: NacidFlowStepStatus.WaitingForRetry, name: "Чака повторен опит" },
  { id: NacidFlowStepStatus.WaitingForManualAction, name: "Чака ръчна намеса" },
  { id: NacidFlowStepStatus.Failed, name: "Неуспешна" },
  { id: NacidFlowStepStatus.Cancelled, name: "Отказана" },
];

export const NacidFlowStepStatusColorMap = {
  [NacidFlowStepStatus.Pending]: "default",
  [NacidFlowStepStatus.InProgress]: "primary",
  [NacidFlowStepStatus.Succeeded]: "success",
  // Already applied at NACID is a success, not a failure — the step's work is done.
  [NacidFlowStepStatus.SkippedAlreadyApplied]: "success",
  [NacidFlowStepStatus.WaitingForRetry]: "info",
  [NacidFlowStepStatus.WaitingForManualAction]: "warning",
  [NacidFlowStepStatus.Failed]: "error",
  [NacidFlowStepStatus.Cancelled]: "default",
};

export const NacidFlowTypeChoices = [
  { id: NacidFlowType.CreatePerson, name: "Създаване на лице" },
  { id: NacidFlowType.CreateForeignPerson, name: "Създаване на чужденец" },
  { id: NacidFlowType.EnrollStudent, name: "Записване на студент" },
  { id: NacidFlowType.AdvanceSemester, name: "Записване в следващ семестър" },
  { id: NacidFlowType.InterruptStudies, name: "Прекъсване на обучение" },
  { id: NacidFlowType.RestoreStudentRights, name: "Възстановяване на студентски права" },
  { id: NacidFlowType.TransferSpecialityInternal, name: "Преместване в друга специалност" },
  { id: NacidFlowType.TransferUniversityOut, name: "Преместване в друго висше училище" },
  { id: NacidFlowType.IncomingMobility, name: "Входяща мобилност" },
  { id: NacidFlowType.SecondSpeciality, name: "Втора специалност" },
  { id: NacidFlowType.TerminateStudies, name: "Приключване на обучение" },
  { id: NacidFlowType.GraduateStudent, name: "Дипломиране" },
  { id: NacidFlowType.RecordProtocol, name: "Записване на протокол" },
  { id: NacidFlowType.IssueDiploma, name: "Издаване на диплома" },
  { id: NacidFlowType.UpdatePersonContacts, name: "Промяна на контакти" },
  { id: NacidFlowType.UpdatePreviousEducation, name: "Промяна на предходно образование" },
  { id: NacidFlowType.UpdateFacultyNumber, name: "Промяна на факултетен номер" },
  { id: NacidFlowType.RepairPeriod, name: "Корекция на период" },
];

export const NacidFlowSourceChoices = [
  { id: NacidFlowSource.Event, name: "Събитие" },
  { id: NacidFlowSource.SystemApi, name: "Системно API" },
  { id: NacidFlowSource.RecoveryJob, name: "Възстановителна задача" },
  { id: NacidFlowSource.Admin, name: "Администратор" },
];

export const NacidFailureClassChoices = [
  { id: NacidFailureClass.Transient, name: "Временна грешка" },
  { id: NacidFailureClass.RateLimited, name: "Ограничение на заявките" },
  { id: NacidFailureClass.AlreadyApplied, name: "Вече приложено" },
  { id: NacidFailureClass.BusinessRejection, name: "Отказано от НАЦИД" },
  { id: NacidFailureClass.Validation, name: "Невалидни данни" },
  { id: NacidFailureClass.ManualIntervention, name: "Изисква ръчна намеса" },
  { id: NacidFailureClass.Unknown, name: "Неразпозната грешка" },
];

export const NacidFailureClassColorMap = {
  [NacidFailureClass.Transient]: "info",
  [NacidFailureClass.RateLimited]: "info",
  [NacidFailureClass.AlreadyApplied]: "success",
  [NacidFailureClass.BusinessRejection]: "error",
  [NacidFailureClass.Validation]: "error",
  [NacidFailureClass.ManualIntervention]: "warning",
  [NacidFailureClass.Unknown]: "error",
};

export const NacidProbeOutcomeChoices = [
  { id: NacidProbeOutcome.NotProbed, name: "Непроверена" },
  { id: NacidProbeOutcome.Absent, name: "Липсва в НАЦИД" },
  { id: NacidProbeOutcome.Present, name: "Намерена в НАЦИД" },
  { id: NacidProbeOutcome.Unavailable, name: "Проверката е неуспешна" },
];

export const NacidProbeOutcomeColorMap = {
  [NacidProbeOutcome.NotProbed]: "default",
  [NacidProbeOutcome.Absent]: "default",
  [NacidProbeOutcome.Present]: "success",
  [NacidProbeOutcome.Unavailable]: "warning",
};

export const PublicationSourceChoices = [
  { id: PublicationSource.Scopus, name: "Scopus" },
  { id: PublicationSource.WebOfScience, name: "Web of Science" },
];
